import {Button, DirectionalIcon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

interface ActivationGlobalCtaProps {
  isVisible: boolean;
  onClick?: () => void;
  isReadyToSubmit: boolean;
  hasProgress?: boolean;
  isLoading?: boolean;
  isTrustActive?: boolean;
}

export const ActivationGlobalCta: FC<ActivationGlobalCtaProps> = ({
  isVisible,
  onClick,
  isReadyToSubmit,
  hasProgress = false,
  isLoading = false,
  isTrustActive = false
}) => {
  const {t} = useTranslation('trustAccounts');

  if (!isVisible) return null;

  const arrowIcon = <DirectionalIcon name="arrow-forward" />;

  return (
    <div
      className="absolute inset-x-0 bottom-0 border-t border-border-subtle bg-background-secondary px-6 py-6 flex justify-end"
      data-slot="activation-global-cta"
    >
      {isTrustActive ? (
        <Button variant="primary" onClick={onClick}>
          {t('activation.action.openTrustAccount')}
          {arrowIcon}
        </Button>
      ) : (
        <Button variant="primary" onClick={onClick} isLoading={isLoading}>
          {isReadyToSubmit
            ? t('activation.action.submitTrustAccount')
            : hasProgress
              ? t('activation.action.continueTrustAccount')
              : t('activation.action.startTrustAccount')}
          {isReadyToSubmit && !isLoading && arrowIcon}
        </Button>
      )}
    </div>
  );
};
